<template>
    <PrimeDialog
        :header="'Кадрирование фона (' + requiredWidth + ' x ' + requiredHeight + ')'"
        v-model:visible="visible"
        :modal="true"
        :closable="true"
        :style="{ width: '80vw', maxWidth: '900px' }"
    >
        <p class="mb-3">Соотношение сторон изображения не совпадает с требуемым. Выберите область для кадрирования.</p>

        <div class="crop-container">
            <img ref="imageEl" :src="imageSrc" style="max-width: 100%; display: block" />
        </div>

        <template #footer>
            <PrimeButton label="Отмена" icon="pi pi-times" @click="onCancel" class="p-button-text" />
            <PrimeButton label="Применить" icon="pi pi-check" @click="onApply" />
        </template>
    </PrimeDialog>
</template>

<script setup>
import { ref, computed, watch, nextTick, onBeforeUnmount, defineProps, defineEmits } from 'vue';
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.min.css';

const BG_DIMENSIONS = {
    L: { width: 1126, height: 796 },
    P: { width: 796, height: 1126 },
};

const props = defineProps({
    modelValue: { type: Boolean, default: false },
    imageSrc: { type: String, default: '' },
    imageWidth: { type: Number, default: 0 },
    imageHeight: { type: Number, default: 0 },
    orientation: { type: String, default: 'L' },
    filename: { type: String, default: '' },
});

const emit = defineEmits(['update:modelValue', 'apply', 'cancel']);

const imageEl = ref(null);
let cropper = null;

const requiredWidth = computed(() => BG_DIMENSIONS[props.orientation].width);
const requiredHeight = computed(() => BG_DIMENSIONS[props.orientation].height);

const visible = ref(props.modelValue);

watch(() => props.modelValue, (val) => {
    visible.value = val;
    if (val) {
        nextTick(() => nextTick(() => initCropper()));
    }
});

watch(visible, (val) => {
    emit('update:modelValue', val);
    if (!val) {
        destroyCropper();
    }
});

function initCropper() {
    destroyCropper();
    if (!imageEl.value) return;

    const dims = BG_DIMENSIONS[props.orientation];

    cropper = new Cropper(imageEl.value, {
        aspectRatio: dims.width / dims.height,
        viewMode: 1,
        autoCropArea: 1,
        movable: false,
        rotatable: false,
        scalable: false,
        zoomable: false,
        guides: true,
        center: true,
        background: true,
        responsive: true,
    });
}

function destroyCropper() {
    if (cropper) {
        cropper.destroy();
        cropper = null;
    }
}

function onApply() {
    if (!cropper) return;

    const data = cropper.getData(true);
    emit('apply', {
        filename: props.filename,
        orientation: props.orientation,
        crop_x: data.x,
        crop_y: data.y,
        crop_width: data.width,
        crop_height: data.height,
    });
    visible.value = false;
}

function onCancel() {
    visible.value = false;
    emit('cancel');
}

onBeforeUnmount(() => destroyCropper());
</script>

<style scoped>
.crop-container {
    max-height: 60vh;
    overflow: hidden;
}
</style>
